import { checkPropTypes } from 'prop-types';
import React from 'react';
import classes from './index.css'
export default function Workroles(props){

    var btnClass = props.showSect ? classes.btnPressed : classes.btnNotPressed
    return(
        <div 
            className= {classes.btnLvl1 + ' ' + btnClass}
            onClick={props.toggleWrkroles}
        >
            <h2><span className={classes.btnIcon}><i className="fas fa-id-badge"></i> </span> Workroles </h2>
        </div>
    )
}